import AnalyticsService, {
  PointEventNameAMP,
  PointParamNameAMP,
  ParamNameAMP,
  EventNameGTM,
} from 'application/services/AnalyticsService';
import { SmartlkPointCreateMutationInput, StandardizedAddressPureType } from '@shared/api/graphql/generated';

import { PointCreateModalPages } from './types';

export const getPointCreateMutationInput = async (
  companyId: string,
  addressName: string,
  getStandardizedPoints: (queryParams: string) => Promise<StandardizedAddressPureType[]>
): Promise<SmartlkPointCreateMutationInput> => {
  const defaultTimezone = 'Europe/Moscow';
  const requestData = await getStandardizedPoints(addressName);
  const standardizedPoint = requestData?.length > 0 ? requestData[0] : null;
  const timezone = requestData ? standardizedPoint?.timezone : defaultTimezone;

  const addressData = standardizedPoint && {
    fiasId: standardizedPoint.fiasId,
    street: standardizedPoint.street,
    country: standardizedPoint.country,
    city: standardizedPoint.city,
    region: standardizedPoint.region,
    postalCode: standardizedPoint.postalCode,
    latitude: Number(standardizedPoint.latitude),
    longitude: Number(standardizedPoint.longitude),
    fullAddress: standardizedPoint.address,
  };

  const input: SmartlkPointCreateMutationInput = {
    companyId,
    address: addressName,
    timezone,
    createWebDevice: false,
    addressData,
  };

  return input;
};

export const sendEventsAfterPointCreating = (pointId: string, pointEnabled: boolean, page: PointCreateModalPages) => {
  AnalyticsService.event(PointEventNameAMP.POINT_CREATED, {
    [PointParamNameAMP.POINT_ID]: pointId,
    [ParamNameAMP.CALLED_FROM]: page,
    [PointParamNameAMP.POINT_IS_ENABLED]: pointEnabled,
  });

  AnalyticsService.eventGTM(EventNameGTM.ADDRESS_ADDED);
};
